const CLOSED_BATCH_STATE = 'CLOSED'

export function summarizeBatchAfterSampleInsertion(batch, includedSamplesCount) {
  const currentSamplesCount = Number(batch?.total_samples) || 0
  const insertedSamplesCount = Number(includedSamplesCount) || 0
  const totalSamples = currentSamplesCount + insertedSamplesCount
  const capability = Number(batch?.capability)
  const reachedCapability =
    Number.isFinite(capability) &&
    capability > 0 &&
    totalSamples >= capability

  return {
    ...batch,
    total_samples: totalSamples,
    state: reachedCapability ? CLOSED_BATCH_STATE : batch?.state,
  }
}
